import React from 'react';
import styles from './HighlightTitle.module.css';

export default ({ title }) => (
  <div className={styles.highlightTitle}>
    <h3>{title}</h3>
  </div>
);
